var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-wrap"},[_c('svg-icon',{attrs:{"icon-class":"matr1x_fire_play_now","class-name":"sign_in"}}),_c('span',{staticClass:"btn-title"},[_vm._v("PLAY NOW")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }